import { render, staticRenderFns } from "./DelModal.vue?vue&type=template&id=27ecc88a&"
import script from "./DelModal.vue?vue&type=script&lang=js&"
export * from "./DelModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports